import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { IS_API_GATEWAY, IS_PRIVATE_API } from '@personal-area/global/http/models';

import { urls } from '../constants/urls';
import { CountryForm } from '../models/country';
import { CountryChangeStatus } from '../models/status';

@Injectable({ providedIn: 'root' })
export class CountryChangeApiService {
  private _http = inject(HttpClient);

  public changeCountry(data: CountryForm): Observable<void> {
    return this._http.post<void>(urls.country, data, {
      context: new HttpContext()
        .set(IS_PRIVATE_API, true)
        .set(IS_API_GATEWAY, true),
    });
  }

  public getCountryRequestStatus(): Observable<CountryChangeStatus> {
    return this._http.get<CountryChangeStatus>(urls.country, {
      context: new HttpContext()
        .set(IS_PRIVATE_API, true)
        .set(IS_API_GATEWAY, true),
    });
  }
}
